/**
 * Report error actions.
 * @module actions/report_error/report_error
 */

import { REPORT_ERROR, RESET_REPORT_ERROR } from '../../constants/ActionTypes';

/**
 * reportError function
 * @function reportError
 * @param {string} url Content url.
 * @param {Object} data Error report data.
 * @returns {Object} reportError action.
 */
export function reportError(url, data) {
  return {
    type: REPORT_ERROR,
    request: {
      op: 'post',
      path: `${url}/@report_error`,
      data: data,
    },
  };
}


export function resetReportError() {
  return {
    type: RESET_REPORT_ERROR,
  };
}